<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="changltx-1">
        <div class="changltx-1__title">
          <span class="changltx-1__title__text">长龙提醒</span>
        </div>
        <div class="changltx-1__content">
          <div class="changltx-1__content__sidebar">
            <div class="sidebar">
              <div class="sidebar__title">
                <span class="sidebar__title__text">选择彩种</span>
              </div>
              <div class="sidebar__content">
                <div class="sidebar__content__item">
                  <div class="libox">
                    <div class="libox__content">
                      <div v-for="(tab, tabIndex) in tabList" :key="`tab-${tabIndex}`" class="libox__content__item" @click="selectCode(tab)">
                        <div class="checkbox" :class="{'active' : selectFilter.includes(tab) }">
                          <i class="checkbox__select"></i>
                          <label class="checkbox__label">{{ cplist[tab].name }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="changltx-1__content__container">
            <div class="changltx-control">
              <div class="changltx-control__left">
                <div class="menubar">
                  <div class="menubar__item" :class="{'active': type === 'continuous'}" @click="changeType('continuous')">
                    <span class="menubar__item__text">连续开出</span>
                    <div class="menubar__item__lightborder"></div>
                  </div>
                  <div class="menubar__item" :class="{'active': type === 'missing'}" @click="changeType('missing')">
                    <span class="menubar__item__text">连续未开</span>
                    <div class="menubar__item__lightborder"></div>
                  </div>
                </div>
              </div>
              <div class="changltx-control__right">
                <span class="changltx-control__right__text">只显示连续</span>
                <div class="selectbox">
                  <select
                    v-model="selectNumber"
                    class="selectbox__select"
                    @change="changePeriodNumLowerLimit(selectNumber)"
                  >
                    <option v-for="num in 14" :key="num" :value="num + 1" class>{{ num + 1 }}</option>
                  </select>
                </div>
                <span class="changltx-control__right__text">期及以上的长龙</span>
              </div>
            </div>
            <div class="changltx-table">
              <table v-loading="isLoading">
                <thead>
                  <tr>
                    <th>
                      <span>彩种</span>
                    </th>
                    <th>
                      <span>位置</span>
                    </th>
                    <th>
                      <span>{{ type === 'continuous' ? '连开期数' : '连续未开' }}</span>
                    </th>
                    <th>
                      <span>开奖信息</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, index) in type === 'continuous' ? changLongContinuousTable : changLongMissingTable">
                    <tr v-if="index < extendConut" :key="index">
                      <td>
                        <span class>
                          <span>{{ cplist[item.code].name }}</span>
                        </span>
                      </td>
                      <td>
                        <span class>{{ item.fieldName }}{{ item.ruleTypeName }} : {{ item.ruleName }}</span>
                      </td>
                      <td>
                        <span class="」">{{ item[type] }}</span>
                      </td>
                      <td>
                        <a class="" href>
                          <span class="">
                            <nuxt-link :to="`/trend/${item.code}`">
                              <span class="button-primary c8-datebox__item acitve">查看</span>
                            </nuxt-link>
                          </span>
                        </a>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="!noMore">
                    <td colspan="4">
                      <span class="button-primary c8-datebox__item active" @click="loadList">显示更多</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getChangLongContinuousList,
  getChangLongMissingList
} from '@/api/desktop/changltx'

export default {
  name: 'ChangLTX',
  transition: 'layout',
  async asyncData({
    isDev,
    route,
    store,
    env,
    params,
    query,
    req,
    res,
    redirect,
    error
  }) {
    const continusQuery = {
      continuous: 2,
      code: store.state.app.hotLottery.join(',')
    }
    const missingQuery = {
      missing: 2,
      code: store.state.app.hotLottery.join(',')
    }
    const changLongContinuous = getChangLongContinuousList(continusQuery)
    const changLongMissing = getChangLongMissingList(missingQuery)

    const [changLongContinuousList, changLongMissingList] = await Promise.all([
      changLongContinuous,
      changLongMissing
    ])

    if (changLongContinuousList[1] || changLongMissingList[1]) {
      console.error(`连续开出错误`, changLongContinuousList[1])
      console.error(`连续未开出错误`, changLongMissingList[1])
      return {}
    }

    return {
      changLongContinuousTable: changLongContinuousList[0],
      changLongMissingTable: changLongMissingList[0]
    }
  },
  data() {
    return {
      extendConut: 30,
      type: 'continuous',
      selectNumber: 2,
      changLongContinuousTable: [],
      changLongMissingTable: [],
      publicCpList: [],
      // selectFilter: {
      //   hk6: true, // 香港六合彩
      //   ff6: true, // 分分六合彩
      //   sf6: true, // 三分六合彩
      //   js6: true // 極速六合彩
      // },
      selectFilter: [...this.$store.state.app.hotLottery],
      isLoading: false
    }
  },
  computed: {
    // 要生成的tab
    tabList() {
      return this.$store.state.app.hotLottery
    },
    // 每一個tab的詳細內容
    cplist() {
      return this.$store.state.lottery.cpsDetail
    },
    // 顯示更多
    noMore() {
      if (this.type === 'continuous') {
        return this.extendConut >= this.changLongContinuousTable.length
      } else {
        return this.extendConut >= this.changLongMissingTable.length
      }
    }

  },
  watch: {
    selectFilter() {
      this.changeTableData()
    }
  },
  methods: {
    changePeriodNumLowerLimit(num) {
      this.changeTableData(num)
    },
    async changeTableData() {
      this.isLoading = true
      let codeListToString = this.selectFilter.join(',')
      if (codeListToString === '') {
        codeListToString = this.$store.state.app.hotLottery.join(',')
      }
      const continusQuery = {
        continuous: this.selectNumber,
        code: codeListToString
      }
      const missingQuery = {
        missing: this.selectNumber,
        code: codeListToString
      }
      const changLongContinuous = getChangLongContinuousList(continusQuery)

      const changLongMissing = getChangLongMissingList(missingQuery)

      const [
        changLongContinuousList,
        changLongMissingList
      ] = await Promise.all([changLongContinuous, changLongMissing])

      this.isLoading = false

      if (changLongContinuousList[1] || changLongMissingList[1]) {
        console.error(`连续开出错误`, changLongContinuousList[1])
        console.error(`连续未开出错误`, changLongMissingList[1])
        return
      } else {
        this.changLongContinuousTable = changLongContinuousList[0]
        this.changLongMissingTable = changLongMissingList[0]
      }
    },
    selectCode(code) {
      if (this.selectFilter.includes(code)) {
        this.selectFilter.splice(this.selectFilter.indexOf(code), 1)
      } else {
        this.selectFilter.push(code)
      }
    },
    changeType(type) {
      this.type = type
      this.extendConut = 30
    },
    // 一次性載入的數量
    loadList() {
      this.extendConut += 30
    }
  }
}
</script>

<style lang="scss" scoped>
.van-button--default {
  font-size: 0.875rem;
  height: 30px;
  padding: 0 16px;
  &:hover{
    border-color: #178AFF;
    color: #178AFF;
  }
}
</style>
